import React from 'react';
import { Modal } from 'components/Modal';
import { css } from '@emotion/react';
import { theme } from 'styles/theme';
import { Button } from '../Button';
import { useStore } from 'hooks/useStore';
import { useMutation, useQuery } from 'urql';
import { MUTATION_URGENT_REQUEST, QUERY_BOOKER_REQUEST } from 'queries/queries-booker';
import { SpinnerBlock } from '../SpinnerBlock';
import { format } from 'date-fns';

export const NotifyRequestModal = ({
	isOpen,
	onClose,
	url,
}: {
	isOpen: boolean;
	onClose: () => void;
	url: string | null;
}) => {
	const { notifications } = useStore();

	const [request] = useQuery({
		query: QUERY_BOOKER_REQUEST,
		variables: {
			url: url,
		},
	});

	const [{ fetching }, executeUrgentRequest] = useMutation(MUTATION_URGENT_REQUEST);

	const onConfirm = () => {
		//

		executeUrgentRequest({
			id: url,
		}).then((result) => {
			// console.log(result);

			if (result?.error) {
				// VYHODIT ERROR
				return false;
			} else {
				notifications.addNotification({
					title: '✅ Hotovo',
					message: 'Urgence poptávky odeslána.',
				});
				onClose();
			}
		});
	};

	// GET REQUEST BY URL

	return (
		<Modal width={480} isOpen={isOpen} close={onClose}>
			<div
				css={css`
					padding: 32px 24px 24px;
				`}
			>
				{request.fetching && <SpinnerBlock />}
				{!request.fetching && (
					<>
						<div
							css={[
								css`
									display: flex;
									align-items: center;
									justify-content: center;

									flex-direction: column;

									padding: 12px 0 32px;
									text-align: center;
								`,
							]}
						>
							<div
								css={css`
									font-size: 20px;
									line-height: 32px;
									font-weight: 600;
									margin-bottom: 4px;
								`}
							>
								Chcete zaurgovat poptávku?
							</div>
							<div
								css={[
									css`
										color: ${theme.color.text[300]};
									`,
								]}
							>
								{request.data.request.artist.name} ·{' '}
								{format(new Date(request.data.request.event_date), 'dd. MM. yyy')} ·{' '}
								{request.data.request.event_address_place} ·{' '}
								{request.data.request.event_address_city}
							</div>

							<div
								css={css`
									display: flex;
									align-items: center;
									justify-content: center;
									// border: 1px solid ${theme.color.primary['400']};
									background: #fafaff;
									border-radius: 12px;
									padding: 12px 20px;
									margin-top: 24px;
									width: 100%;
								`}
							>
								<div>
									<div
										css={css`
											font-weight: 600;
										`}
									>
										Email bude odeslán na
									</div>
									<div
										css={css`
											font-size: 13px;
										`}
									>
										{request.data.request.main_email}
									</div>
								</div>
							</div>
						</div>
						<div
							css={css`
								display: flex;
								justify-content: space-between;
							`}
						>
							<Button outline onClick={onClose}>
								Zrušit
							</Button>

							<Button isProcessing={fetching} onClick={onConfirm}>
								Ano, odeslat
							</Button>
						</div>
					</>
				)}
			</div>
		</Modal>
	);
};
